export enum SceneDefinitionGeoreferenceMode {
    LOCAL = "LOCAL",
    GLOBAL = "GLOBAL",
}
